import { render, staticRenderFns } from "./ViewProperty.vue?vue&type=template&id=652ec166&scoped=true"
import script from "./ViewProperty.vue?vue&type=script&lang=js"
export * from "./ViewProperty.vue?vue&type=script&lang=js"
import style0 from "./ViewProperty.vue?vue&type=style&index=0&id=652ec166&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652ec166",
  null
  
)

export default component.exports